import { gql } from '@apollo/client';

export const ADD_PATIENT_ADDRESS = gql`
  mutation AddAddress($data: CreatePatientAddressInput!) {
    createPatientAddressForPatient(data: $data) {
      id
    }
  }
`;
